import React from 'react'
import DepartmentDetailsPage from 'src/components/DepartmentDetailsPage/DepartmentDetailsPage'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { departmentDetailsRouteProps } from 'src/navigation/routeProps'

const DepartmentDetailsAppRoute: AppRoute = {
  id: AppLocation.DepartmentDetails,
  routeProps: departmentDetailsRouteProps,
  component: <DepartmentDetailsPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default DepartmentDetailsAppRoute
